import { Dropdown } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { ComplianceMeetingStakeholderTable } from '../../components/CompilanceMeetingStakeholderTable'
import { getComplianceExportCsv } from '../../../compliance-meeting/core/_requests'
import { toast } from 'react-toastify'
import threeDots from '../../../../../_metronic/assets/images/svg/investor/threeDots.svg'
import { useEffect, useState } from 'react'
import searchIcon from '../../../../../_metronic/assets/images/svg/data-room/search-icon-grey.svg'
import clsx from 'clsx'
import { KTSVG, toAbsoluteUrl } from '../../../../../_metronic/helpers'
import { useStakeholders } from '../../Stakeholders'
import { Filter } from '../../../widgets/components/General/Filter'
import Skeleton from 'react-loading-skeleton'

export const Meetingtable = ({ email }: { email?: string }) => {
  const { formatMessage } = useIntl()
  const [globalFilter, setGlobalFilter] = useState('')
  const {
    setComplianceMeetingFilter,
    selectedComplianceMeetingTypeFilter,
    selectedComplianceMeetingDateFilter,
  } = useStakeholders()

  const onExportComplianceMeeting = async () => {
    try {
      const {
        data: { data: values, success, errors },
      } = await getComplianceExportCsv(undefined, email)
      if (success) {
        toast.success(formatMessage({ id: 'Documents exported successfully' }))
        const url = window.URL.createObjectURL(new Blob([values]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'compliance_meeting.csv')
        document.body.appendChild(link)
        link.click()
        link.remove()
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err: any) {
      console.log(err)
    }
  }
  return (
    <>
      <div className='d-flex flex-column w-100'>
        <div className='w-100'>
          <div className='rounded-2 py-1 pb-4 position-relative'>
            <div className='d-flex mb-4 justify-content-md-end justify-content-between w-100 align-items-center'>
              {/* <h1 className='font-size-16 mb-0 ps-2'>{formatMessage({ id: 'Meetings' })}</h1> */}
              <div className='d-flex gap-2 align-items-centers flex-md-row flex-column w-100 w-md-auto'>
                <div className='d-flex align-items-center gap-2 justify-content-md-end justify-content-between height-36'>
                  <div className='h-100 border bg-white d-flex rounded'>
                    <button
                      className={clsx('text-clr88 btn btn-sm btn-flex fw-semibold font-size-12 height-36')}
                      id='fc-toogle'
                      title='Sort and Filter'
                      data-bs-toggle='tooltip'
                      data-bs-placement='left'
                      data-bs-dismiss='click'
                      data-bs-trigger='hover'
                      onClick={() => {
                        setComplianceMeetingFilter(true)
                      }}
                    >
                      <KTSVG
                        path={toAbsoluteUrl('/media/icons/duotune/general/gen031.svg')}
                        className='svg-icon-6 svg-icon-muted me-1'
                      />
                      <span className='d-none d-md-block'>{formatMessage({ id: 'Filter' })}</span>
                      {selectedComplianceMeetingTypeFilter || selectedComplianceMeetingDateFilter
                        ? '*'
                        : ''}
                    </button>
                  </div>

                  <form className='align-items-center d-flex w-100 w-md-auto'>
                    <span className='svg-icon svg-icon-3 position-absolute ms-2'>
                      <img src={searchIcon} alt='Search icon' />
                    </span>
                    <DebouncedInput
                      value={globalFilter ?? ''}
                      onChange={(value) => setGlobalFilter(String(value))}
                      className='bg-body form-control form-control-flush ps-10 rounded-2 font-size-12 font-weight-400'
                      placeholder='Search by name or email'
                    />
                  </form>
                  <div className='dropdown-export-container'>
                    <Dropdown>
                      <Dropdown.Toggle className='btn btn-white table-three-dots dots-container'>
                        <img src={threeDots} alt='' className='three-dots-image' />
                      </Dropdown.Toggle>

                      <Dropdown.Menu className='m-1'>
                        <Dropdown.Item className='text-dark ps-5' onClick={onExportComplianceMeeting}>
                          {formatMessage({ id: 'Export to CSV' })}
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </div>
            <div className='table table-responsive h-100 '>
              {!email ? (
                <>
                  <Skeleton
                    width={'100%'}
                    height={48}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                  <Skeleton
                    width={'100%'}
                    height={48}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                </>
              ) : (
                <ComplianceMeetingStakeholderTable
                  email={email}
                  globalFilter={globalFilter}
                  setGlobalFilter={setGlobalFilter}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <Filter />
    </>
  )
}

function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}: {
  value: string | number
  onChange: (value: string | number) => void
  debounce?: number
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>) {
  const [value, setValue] = useState(initialValue)

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value)
    }, debounce)

    return () => clearTimeout(timeout)
  }, [value, debounce, onChange])
  return <input {...props} value={value} onChange={(e) => setValue(e.target.value)} />
}
